export const STATS_API_BASE_URL = 'https://unbot.io/api/v1.0/stats';
export const MODELS_API_BASE_URL = 'https://unbot.io/api/v1.0/models';
export const MEDIAS_API_BASE_URL = 'https://unbot.io/api/v1.0/medias';
